import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

export default function ImportanceMenu({ onSelect, item }) {
  return (
    <div className="extra-menu">
      <ul>
        <li
          className="green"
          onClick={evt => {
            evt.stopPropagation();
            onSelect(false, item);
          }}
        >
          Nice to have
        </li>
        <li
          className="purple"
          onClick={evt => {
            evt.stopPropagation();
            onSelect(true, item);
          }}
        >
          Must have
        </li>
      </ul>
    </div>
  );
}

ImportanceMenu.propTypes = {
  item: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
};
